export default __webpack_public_path__ + "static/1597-675202a42db39a0765d0dbc183a7dd24.gif";